const enum AudioCallConst {
  QUESTIONS_AMOUNT = 10,
  MAX_PAGES_INDEX = 29,
  MAX_WORDS_INDEX = 19,
  ANSWERS_AMOUNT = 5,
}

export default AudioCallConst;
